<!------------------------------------------- template ------------------------------------------->
<template>
  <div :class="{ page: bgColorBlue }" class="pageWhite">
    <div class="wholesale_programme_title">
      <div class="wholesale_programme_title_text">
        七大产品体系支撑
        <img src="../../assets/img/title3@2x.png" alt="" />
      </div>
      <div class="zhexian"></div>
    </div>
    <div class="menu-ul" @click="goAnchor(2)">
      <!-- <div class="swiper-button-prev" slot="button-prev">
        <div class="prev_btn">
          <i class="el-icon-arrow-left"></i>
        </div>
      </div> -->
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in list" :key="index" class="one">
          <img :src="item.img" alt="" />
          <div>{{ item.title }}</div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <!-- <div class="swiper-button-next" slot="button-next">
        <div class="prev_btn">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div> -->
    </div>
  </div>
</template>

<!-------------------------------------------- script -------------------------------------------->
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: '',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    bgColorBlue: {
      type: Boolean
    }
  },

  data() {
    return {
      // swiperOption: {
      //   loop: false,
      //   autoplay: {
      //     delay: 3000,
      //     stopOnLastSlide: false,
      //     disableOnInteraction: false
      //   },
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true
      //   }
      // },
      list: [
        {
          title: '市场运营管理平台',
          img: require('../../assets/img/ld_1@2x.png')
        },
        {
          title: '商户进销存平台',
          img: require('../../assets/img/ld_2@2x.png')
        },
        {
          title: '支付结算系统',
          img: require('../../assets/img/ld_3@2x.png')
        },
        {
          title: '物联网平台',
          img: require('../../assets/img/ld_4@2x.png')
        },
        {
          title: '无人值守地磅',
          img: require('../../assets/img/ld_5@2x.png')
        },
        {
          title: '电子会员系统',
          img: require('../../assets/img/ld_6@2x.png')
        },
        {
          title: '线上商城系统',
          img: require('../../assets/img/ld_7@2x.png')
        }
      ],
      swiperOption: {
        autoplay: {
          delay: 0 //走马灯
        },
        slidesPerView: 'auto', //设置slider容器能够同时显示的slides数量
        speed: 2000, //滑动速度
        spaceBetween: 0, //slide之间的距离（单位px
        // slidesPerGroup:1, //定义slides的数量多少为一组
        centeredSlides: false, //设定为true时，活动块会居中，而不是默认状态下的居左
        loop: true, //会在原本slide前后复制若干个slide(默认一个)并在合适的时候切换，让Swiper看起来是循环的
        loopFillGroupWithBlank: false, //不到6个的组，剩下的slice会用空白填满
        loopedSlides: 4,
        loopAdditionalSlides: 7,
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        allowTouchMove: false, //禁止手动拖动滑动
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        preventLinksPropagation: false //拖动Swiper时阻止click事件,如果没有禁止拖动需要设置此项
      }
    }
  },

  /* 一.生命周期函数 */
  created() {},

  /* 二.监控函数 */
  watch: {},

  computed: {},

  /* 三.内部功能函数 */
  methods: {
    /* ----------------------事件调用函数------------------------ */
    // 事件调用函数注释
    handleXxx() {},

    /* ----------------------内部调用函数------------------------ */
    // 内部功能函数注释
    doSomething() {},

    /* ----------------------服务请求函数------------------------ */
    // 服务请求函数注释
    ajax_getXxx() {},

    //导航栏点击事件
    goAnchor(index) {
      this.$router.push('/systemPlatform')
      this.$store.commit('Navigation', index)
    }
  }
}
</script>

<!--------------------------------------------- style -------------------------------------------->
<style scoped>
.pageWhite {
  background: #fff;
  padding-top: 1px;
  padding-bottom: 1px;
  box-sizing: border-box;
}

.page {
  background: #f7fbff;
  padding-top: 1px;
  padding-bottom: 1px;
  box-sizing: border-box;
}

/* 覆盖按钮本身样式，使用img是为了兼容ie，swipe本身的按钮样式是在after里设置的font-family*/
.prev_btn {
  width: 72px;
  height: 130px;
  line-height: 130px;
  text-align: center;
  background: #dfeafd;
  font-size: 48px;
  color: #ffffff;
}

.case_swiper_box {
  width: 376px;
  height: 400px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 5px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  padding: 28px 28px 0;
}

.case_swiper_box img {
  width: 320px;
  height: 180px;
}

.case_title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin: 16px auto 14px;
}

.case_content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  text-align: left;
}

>>> .swiper-button-prev {
  position: relative;
  margin: 16px 0 9px 0;
  color: rgb(101, 101, 101);
  top: -50px;
  left: -104px;
  right: 0;
  background-image: none;
}

>>> .swiper-button-next {
  position: relative;
  margin: 16px 0 9px 0;
  color: rgb(101, 101, 101);
  top: -50px;
  left: 62px;
  right: 0;
  background-image: none;
}

>>> .swiper-button-prev:after {
  content: none;
}

>>> .swiper-button-next:after {
  content: none;
}

.menu-ul {
  /*width: 1444px;*/
  width: 1200px;
  /*width: calc(100% - 476px);*/
  display: flex;
  align-items: center;
  /* height: 400px; */
  margin: 50px auto 48px;
}

.one {
  position: relative;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 22px;
  color: #ffffff;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  cursor: pointer;
}
.one img {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.menu-list {
  width: 1128px;
  display: flex;
  align-items: center;
  height: 62px;
  background: #ffffff;
  font-size: 16px;
  color: #666666;
}

>>> .swiper-slide {
  /*width: 100% !important;*/
  width: 274px !important;
}

.swiper-slide span {
  display: block;
  padding: 16px 0 9px 0;
  height: 62px;
}

>>> .swiper-container {
  /*overflow: unset;*/
  /* padding: 20px; */
}

.wholesale_programme_title {
  width: 1200px;
  margin: 0 auto;
}

.wholesale_programme_title_text {
  width: 240px;
  text-align: center;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin: 73px auto 0;
  z-index: 99;
}

.wholesale_programme_title_text img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -13px;
  z-index: -1;
}

.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}
</style>
